import React from 'react'
import PageHead from '../components/Common/PageHead'
import { Helmet } from 'react-helmet-async'

const TermsOfServices = () => {
  return (
    <>
    <Helmet>
    <title>Terms Of Services | AI Agency Directory</title>
      <meta name='description'
        content='Review the AI Agency Directory Terms of Service to understand our guidelines on listings, payments, and user responsibilities. Stay compliant—read now!' />
    </Helmet>
      <PageHead pagename='Terms of Services' />
      <div className='m-5 md:m-20 '>
    <p><strong>Effective Date:</strong> November 11, 2024</p>

    <p>Welcome to <strong>AI Agency Directory</strong> ("we," "us," or "our"). These Terms of Service ("Terms") govern your access to and use of the AI Agency Directory website (the "Service"), including any content, functionality, and services offered on or through aiagencydirectory.com (the "Website"). By creating an account, uploading agency information, or purchasing subscription plans, you agree to abide by these Terms. Please read them carefully.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>1. Acceptance of Terms</h2>
    <p>By accessing or using our Service, you accept and agree to these Terms and our Privacy Policy. If you do not agree to any part of these Terms, please do not use our Service.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>2. Eligibility</h2>
    <p>To use the Service, you must be at least 18 years old and capable of entering into a binding agreement. By using the Service, you represent and warrant that you meet these requirements.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>3. Account Creation and Security</h2>
    <ul>
        <li>You are required to create an account to access certain features of the Service.</li>
        <li>You agree to provide accurate, current, and complete information during registration and to update it as necessary.</li>
        <li>You are responsible for maintaining the security of your account and for any actions that occur under your account.</li>
    </ul>

    <h2 className='text-primary text-2xl font-bold my-3'>4. User-Generated Content</h2>
    <ul>
        <li><strong>Account Holders</strong> can upload information about AI agencies, including but not limited to agency names, descriptions, locations, and services ("Content").</li>
        <li>By uploading Content, you grant us a non-exclusive, royalty-free, perpetual license to use, display, distribute, and modify your Content in connection with the Service.</li>
        <li>You agree that the Content you upload will not be illegal, infringing, offensive, or otherwise objectionable. We reserve the right to remove Content that violates these Terms or applicable laws.</li>
    </ul>

    <h2 className='text-primary text-2xl font-bold my-3'>5. Subscription Plans and Payment</h2>
    <ul>
        <li><strong>AI Agency Directory</strong> offers subscription plans that provide access to premium features.</li>
        <li>By purchasing a subscription plan, you agree to pay the specified fees associated with that plan.</li>
        <li>All fees are non-refundable unless otherwise stated in our Refund Policy.</li>
        <li>We reserve the right to change our subscription fees or introduce new fees at any time. Any changes will apply only to new or renewed subscriptions.</li>
    </ul>

    <h2 className='text-primary text-2xl font-bold my-3'>6. Termination of Account</h2>
    <ul>
        <li>We may suspend or terminate your account at any time if we believe you have violated these Terms or engaged in conduct that harms us or other users.</li>
        <li>You may cancel your account at any time. However, any fees paid for subscriptions are non-refundable.</li>
    </ul>

    <h2 className='text-primary text-2xl font-bold my-3'>7. Intellectual Property</h2>
    <p>All content and materials provided by AI Agency Directory, including but not limited to text, graphics, logos, and software, are the property of AI Agency Directory or its licensors. You are granted a limited, non-exclusive license to access and use the Service for personal or commercial purposes as permitted by these Terms.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>8. Prohibited Conduct</h2>
    <p>You agree not to misuse the Service, including but not limited to:</p>
    <ul>
        <li>Uploading false, misleading, or harmful content</li>
        <li>Using automated systems to interact with the Service</li>
        <li>Attempting to disrupt or compromise the Service or its security</li>
        <li>Engaging in any activity that infringes on the rights of others or violates any applicable law</li>
    </ul>

    <h2 className='text-primary text-2xl font-bold my-3'>9. Disclaimer of Warranties</h2>
    <p>The Service is provided on an "as is" and "as available" basis, without warranties of any kind, either express or implied. We do not warrant that the Service will be uninterrupted, error-free, or secure. You use the Service at your own risk.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>10. Limitation of Liability</h2>
    <p>To the fullest extent permitted by law, AI Agency Directory shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your use of the Service.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>11. Indemnification</h2>
    <p>You agree to indemnify and hold harmless AI Agency Directory, its affiliates, and their respective officers, directors, employees, and agents, from any claims, liabilities, damages, losses, or expenses arising out of or related to your violation of these Terms or your use of the Service.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>12. Changes to the Terms</h2>
    <p>We reserve the right to update or modify these Terms at any time. If we make significant changes, we will notify you by email or by posting a notice on our Website. Your continued use of the Service after any changes indicates your acceptance of the new Terms.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>13. Governing Law</h2>
    <p>These Terms and your use of the Service are governed by the laws of United States. Any disputes arising out of or related to these Terms will be resolved in the courts of United States.</p>

    <h2 className='text-primary text-2xl font-bold my-3'>14. Contact Information</h2>
    <p>If you have any questions about these Terms, please contact us at support@aiagencydirectory.com.</p>
        
      </div>
    </>
  )
}

export default TermsOfServices